import { getPinSize, MULTIICON_RATIO, PinIcon, PinSize } from '@/constants/canvas';
import { ONE, ZERO } from '@/constants/common';
import { createCanvas } from '@/utils/canvas/getCanvas';

const drawIconOnCanvas = (
  ctx: CanvasRenderingContext2D,
  icon: HTMLCanvasElement,
  index: number,
  pinSize: PinSize,
): void => {
  ctx.drawImage(icon, ZERO, index * pinSize.height * MULTIICON_RATIO);
};

export const getCavasMultiIcon = (
  icons: HTMLCanvasElement[],
  pinIcon: PinIcon,
): HTMLCanvasElement => {
  const pinSize = getPinSize(pinIcon);
  const canvas = createCanvas({
    width: pinSize.width,
    height: pinSize.height * (ONE + (icons.length - ONE) * MULTIICON_RATIO),
  });

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return canvas;
  }

  icons.reverse().forEach((icon, index) => drawIconOnCanvas(ctx, icon, index, pinSize));

  return canvas;
};
